import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { reduxForm, registerField, SubmissionError, formValueSelector } from 'redux-form'
import flowRight from 'lodash/flowRight'
import includes from 'lodash/includes'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { translate } from 'loankeeper-common/helpers'
import transformProps from 'loankeeper-common/containers/transformProps'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'
import { withUserConfig, withSystemConfig, withLookups } from 'shared'

import { beforeEntryAddEdit, view as eventView } from '../../../store/event'

import { LKModalContainer, actions as LKModalActions } from '../../shared/LKModal'

import commonBaseContainers from '../containers/common'
import {
  FORM_NAME,
  ORDER_CASH_OUT_ADD_IN_NAVIGATION,
  ORDER_CASH_IN_ADD_IN_NAVIGATION,
  ORDER_CASH_OUT_COPY,
  ORDER_CASH_IN_COPY,
} from './constants'
import { printReport } from '../helpers'

import { translateLKMessage, translateFrmWebMsg } from '../translate'
import { getClientReqFields, getClientSelects } from 'src/store/client'
import { accountViewGetBalance } from 'src/store/account'
import { accEntryAdd } from 'src/store/accEntry'

let session = {}

let isResubmit = false

const matrixError = {}

export function markResubmit() {
  isResubmit = true
}

export const reduxFormContainer = flowRight(
  withRouter,
  reduxForm({
    form: FORM_NAME,

    onSubmitFail: (errors, dispatch, submissionError) => {
      if (errors && errors._error) {
        dispatch(LKModalActions.openError(errors._error))
      } else if (submissionError && submissionError.errors && submissionError.errors.DocDate) {
        dispatch(LKModalActions.openError(translate('LKMESSAGE-ERR_ACCESS_DENIED')))
      } else if (submissionError !== matrixError) {
        dispatch(LKModalActions.openError(translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS'), 'ERR_FILL_REQUIRED_FIELDS'))
      }
    },

    validate: (values, { cashOut, name }) => {
      const errors = {}

      if (values.CardNumber !== values.CardNumberConfirm) {
        errors.CardNumberConfirm = translate('frm_web_messages-DO_NOT_MATCH')
      }

      if (cashOut) {
        if (!values.DebitChosenAccNo) {
          errors.DebitAccNo = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
        }
      } else if (!values.CreditChosenAccNo) {
        errors.CreditAccNo = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
      }

      if (!values.Amount) {
        errors.Amount = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
      }

      if (!values.Amount) {
        errors.Amount = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
      }

      if (!LKDate.isValid(values.DocDate)) {
        errors.DocDate = translateFrmWebMsg('INVALID_DATE')
      }

      if (values.chosenAccountTypeID === 9) {
        if (values.MoneyTransferCountryID === 1) {
          errors.MoneyTransferCountryID = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
        }

        if (values.MoneyTransferSystemID === 1) {
          errors.MoneyTransferSystemID = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
        }

        if (!values.moneytransfer_code) {
          errors.moneytransfer_code = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
        }

        if (!values.moneytransfer_agent) {
          errors.moneytransfer_agent = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
        }
        if (name === 'OrderCashOutAddInNavigation') {
          if (
            !values.moneytransfer_bplace &&
            !values.moneytransfer_bdate &&
            !values.moneytransfer_address &&
            !values.moneytransfer_doc
          ) {
            errors.moneytransfer_bplace = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'

            errors.moneytransfer_bdate = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'

            errors.moneytransfer_address = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'

            errors.moneytransfer_doc = translateLKMessage('ERR_REQUIRED_FIELD') // 'required'
          }
        }
      }

      return errors
    },

    customSubmit: (val) => val,

    onSubmit: async (values, dispatch, ownProps) => {
      if (
        moment(values.DocDate, 'DD.MM.YYYY').isBefore(moment(ownProps.OpenDay, 'DD.MM.YYYY')) &&
        !ownProps.permissions.MAKE_CLOSEDAY_ENTRIES
      ) {
        return Promise.reject(new SubmissionError({ DocDate: 'invalid' }))
      }

      if (!isResubmit) {
        const apiArgs = values.clientIsChosen
          ? {
              ClientID: values.clientID,
              HashSum_ClientID_: values.clientHash,
            }
          : {
              Name: values.Name,
              Surname: values.Surname,
              Name_ALT: values.Name_ALT,
              Surname_ALT: values.Surname_ALT,
              CellPhone: values.CellPhone,
            }

        apiArgs.OperTypeID = values.OperTypeID
        apiArgs.DebitAccID = values.DebitAccID
        apiArgs.HashSum_DebitAccID_ = values.DebitAccHash
        apiArgs.CreditAccID = values.CreditAccID
        apiArgs.HashSum_CreditAccID_ = values.CreditAccHash
        apiArgs.IDDocID = values.IDDoc && values.IDDoc.ID
        apiArgs.HashSum_IDDocID_ = values.IDDoc && values.IDDoc.HashSum_IDDocID_

        let AMLOperTypeID

        if (values.OperTypeID === 3) {
          AMLOperTypeID = values.chosenAccountTypeID === 9 ? 70 : 40
        } else {
          AMLOperTypeID = values.chosenAccountTypeID === 9 ? 80 : 50
        }

        if (values.chosenAccountTypeID === 9) {
          apiArgs.MoneyTransferCountryID = values.MoneyTransferCountryID
          apiArgs.MoneyTransferAgent = values.moneytransfer_agent
          apiArgs.MoneyTransferSystemID = values.MoneyTransferSystemID
        }

        if ((values.OperTypeID === 3 || values.OperTypeID === 4) && values.clientType === 0) {
          apiArgs.ClientType = 1
        } else {
          apiArgs.ClientType = values.clientType
        }

        try {
          const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = (
            await dispatch(
              beforeEntryAddEdit({
                SP_ACT: values.action === 'edit' ? 1 : 0, // just because it's add action
                AMLOperTypeID,
                Amount: values.Amount,
                CCY: values.CCY,
                PersonalNo: values.CardNumber,
                ...apiArgs,
              }),
            )
          ).payload

          session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }

          if (ErrorLevel === 150 || ErrorLevel === 200) {
            const Data = (await dispatch(eventView({ WHLSessionID, HashSum_WHLSessionID_ }))).payload

            dispatch(
              LKModalActions.open({
                name: ErrorLevel === 150 ? 'ClientValidationResultsConfirm' : 'ClientValidationResults',
                Data,
                ErrorLevel,
              }),
            )

            return Promise.reject(matrixError)
          }
        } catch (e) {
          ownProps.openError(translateLKMessage((e.Error && (e.Error.Message || e.Error.Text)) || 'HINT_ERR_TITLE'))

          return Promise.reject(matrixError)
        }
      } else {
        isResubmit = false
      }

      const newData = {
        action: values.action,
        Authorize: values.Authorize,
        OperTypeID: values.OperTypeID,
        DocDate: values.DocDate,
        OpCodeID: values.OpCodeID,
        DocNo: values.DocNo,
        Amount: values.Amount,
        Comment: values.Comment,
        PersonalNo: values.CardNumber,

        DebitAccID: values.DebitAccID,
        HashSum_DebitAccID_: values.DebitAccHash,
        CreditAccID: values.CreditAccID,
        HashSum_CreditAccID_: values.CreditAccHash,
        LoanID: ownProps.params && ownProps.params.LoanID,
        HashSum_LoanID_: ownProps.params && ownProps.params.LoanHash,
        WHLSessionID: session.WHLSessionID,
        HashSum_WHLSessionID_: session.HashSum_WHLSessionID_,
      }

      if (values.chosenAccountTypeID === 9) {
        newData.MoneyTransferCountryID = values.MoneyTransferCountryID
        newData.MoneyTransferSystemID = values.MoneyTransferSystemID
        newData.MoneyTransferCode = values.moneytransfer_code
        newData.MTA_FullName = values.moneytransfer_agent
        newData.MTA_Address = values.moneytransfer_address
        newData.MTA_DOB = values.moneytransfer_bdate
        newData.MTA_BirthPlace = values.moneytransfer_bplace
        newData.MTA_DocNo = values.moneytransfer_doc
      }

      const isEdit = !values.Client && values.action === 'edit'
      const { detailsTabData: details } = ownProps

      const clientNotChosen = !values.clientIsChosen && (!isEdit || !details.ClientID)

      if (clientNotChosen) {
        newData.Name = values.Name
        newData.Surname = values.Surname
        newData.Name_ALT = values.Name_ALT
        newData.Surname_ALT = values.Surname_ALT
        newData.CellPhone = values.CellPhone
      } else if (values.clientType === 3) {
        newData.Company_ClientID = isEdit ? details.Company_ClientID : values.clientID
        newData.HashSum_Company_ClientID_ = isEdit ? details.HashSum_Company_ClientID_ : values.clientHash

        newData.ClientID = isEdit ? details.ClientID : values.Delegate.ID
        newData.HashSum_ClientID_ = isEdit ? details.HashSum_ClientID_ : values.Delegate.HashSum_ClientID_

        newData.IDDocID = values.IDDoc.ID
        newData.HashSum_IDDocID_ = values.IDDoc.HashSum_IDDocID_
      } else {
        newData.ClientID = isEdit ? details.ClientID : values.clientID
        newData.HashSum_ClientID_ = isEdit ? details.HashSum_ClientID_ : values.clientHash

        if (values.IDDoc) {
          newData.IDDocID = values.IDDoc.ID
          newData.HashSum_IDDocID_ = values.IDDoc.HashSum_IDDocID_
        }
      }

      // temporary fix
      if (isEdit) {
        newData.Name = values.Name
        newData.Surname = values.Surname
        newData.Name_ALT = values.Name_ALT
        newData.Surname_ALT = values.Surname_ALT
        newData.CellPhone = values.CellPhone
      }

      if (ownProps.params) {
        newData.EntryID = ownProps.params.ID
        newData.HashSum_EntryID_ = ownProps.params.hash
        newData.OID = ownProps.params.OID
        newData.HashSum_OID_ = ownProps.params.OIDHash
      }

      if (includes([ORDER_CASH_IN_COPY, ORDER_CASH_OUT_COPY], ownProps.name) && includes([3, 4], ownProps.OperTypeID)) {
        delete newData.HashSum_EntryID_
        delete newData.OID
        delete newData.EntryID
      }

      // return Order.add(newData)
      //UPDATED API REQUEST acc_entry_add_api
      dispatch(accEntryAdd(newData))
        .then((response) => {
          if (!accEntryAdd.fulfilled.match(response)) {
            throw { Error: { Text: response.payload } }
          }
          ownProps.closeModal()

          if (ownProps.onOrderAddEdit) ownProps.onOrderAddEdit(response)

          if (values.OpenAgain) {
            let name = ''

            if (ownProps.OperTypeID === 4 && ownProps.name === ORDER_CASH_OUT_COPY) {
              name = ORDER_CASH_OUT_ADD_IN_NAVIGATION
            } else if (ownProps.OperTypeID === 3 && ownProps.name === ORDER_CASH_IN_COPY) {
              name = ORDER_CASH_IN_ADD_IN_NAVIGATION
            } else {
              name = ownProps.name
            }

            dispatch(LKModalActions.open({ name }))
          }

          let pageName = ''
          if (ownProps.cashOut) {
            pageName = 'printcashout'
          } else if (ownProps.UCCEntry === 1) {
            pageName = 'printcashinucc' // this will be called when Print is checked during account entry ADD
          } else {
            pageName = 'printcashin'
          }

          if (values.action === 'add' && values.print === '1') {
            printReport({
              dispatch,
              OperTypeID: values.OperTypeID,
              page: pageName,
              printOption: values.printOption,
              EntryID: response.Data.EntryID,
              HashSum_EntryID_: response.Data.HashSum_EntryID_,
              history: ownProps.history,
            })
          }
        })
        .catch((error) => {
          if (error.message === 'CLIENT_ALREADY_EXISTS') {
            throw new SubmissionError({ CardNumber: 'already exists' })
          }

          if (error.Error && error.Error.Text === 'ERR_CLIENT_DOB') {
            throw new SubmissionError({ DOB: 'invalid' })
          }

          if (error.Error && error.Error.FailedFields) {
            dispatch(LKModalActions.openError('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS'))

            const submissionErrors = error.Error.FailedFields.reduce(
              (result, current) => ({
                ...result,
                [current.FName]: current.Comment || 'invalid',
              }),
              {},
            )

            throw new SubmissionError(submissionErrors)
          }

          if (error.Error && error.Error.Text) {
            dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text)))
          }
        })
    },
  }),
)

export const commonContainers = flowRight(
  commonBaseContainers,

  withUserConfig(['CashAccounts', 'MyCountryID', 'Print_After_Client_Add']),
  withSystemConfig(['AgeLimitMin', 'AgeLimitMax', 'CashDocAgeMin', 'CashDocAgeMax', 'CellPhoneValidate']),
  withLookups({ type: 'acc', query: 'MT_System as MoneyTransferSystem' }),

  transformProps((props) => {
    const initialAccountForDisabledField =
      props.account && props.account.CCY
        ? props.CashAccounts.filter((account) => account.CCY === props.account.CCY)[0]
        : props.CashAccounts.filter((account) => account.CCY === 'GEL')[0]

    return {
      ...props,
      initialAccountForDisabledField,
    }
  }),
)

export default flowRight(
  LKModalContainer(),

  commonContainers,

  connect(undefined, (dispatch) => ({
    getClientReqFields: (params) => dispatch(getClientReqFields(params)),
    getClientSelects: (params) => dispatch(getClientSelects(params)),
    accountViewGetBalance: (params) => dispatch(accountViewGetBalance(params)),
  })),

  (Component) => {
    class WrappedUcc extends React.Component {
      constructor(props) {
        super(props)

        this.Wrapped = withCallAPI({
          APICall: [
            // Client.getSelects,
            ///UPDATED API REQUEST client_lookups_api
            (params) => props.getClientSelects(params),

            // Account.getBalance,

            (params) =>
              props.accountViewGetBalance({
                AccountID: params.ID,
                HashSum_AccountID_: params.hash,
              }),
            // Client.getRequiredFields(params)
            ///UPDATED API REQUEST client_reqfields_api
            (params) => props.getClientReqFields(params),
          ],
          APIParams: [
            undefined,
            ({ initialAccountForDisabledField }) =>
              !initialAccountForDisabledField
                ? undefined
                : {
                    ID: initialAccountForDisabledField.AccountID,
                    hash: initialAccountForDisabledField.HashSum_AccountID_, // eslint-disable-line
                  },
            () => ({ groupid: 9, typeid: 9 }),
          ],
          transformData: [
            // (response) => ({ clientSelects: response.Data }),
            ///UPDATED API REQUEST client_lookups_api
            ({ payload: response }) => ({ clientSelects: response }),

            // (response) => ({ debitBalance: response ? response.Data.Balance : 0 })
            //UPDATED API REQUEST acc_account_view_api page: 'balance'
            ({ payload: response }) => {
              return { debitBalance: response ? response.Balance : 0 }
            },

            // (response) => {
            //UPDATED API REQUEST client_reqfields_api
            ({ payload: response }) => {
              return {
                requiredFields: response.ReqFields.reduce(
                  (result, current) => ({
                    ...result,
                    [current.FName]: current,
                  }),
                  {},
                ),
              }
            },
          ],
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedUcc
  },

  transformProps((props) => {
    console.log(props)
    const hasAcc = props.initialAccountForDisabledField

    const initialAccount = props.cashOut
      ? {
          CreditAccNo: hasAcc ? props.initialAccountForDisabledField.AccNo : '',
          CreditChosenAccNo: hasAcc ? props.initialAccountForDisabledField.AccNo : '',
          CreditAccID: hasAcc ? props.initialAccountForDisabledField.AccountID : '',
          CreditAccHash: hasAcc ? props.initialAccountForDisabledField.HashSum_AccountID_ : '', // eslint-disable-line
          CreditTitleUNI: hasAcc ? props.initialAccountForDisabledField.TitleUNI : '',
          CreditAccBalance: props.debitBalance,

          DebitAccNo: (props.account && props.account.AccNo) || undefined,
          DebitTitleUNI: (props.account && props.account.TitleUNI) || undefined,
          DebitAccID: (props.account && props.account.ID) || undefined,
          DebitAccHash: (props.account && props.account.hash) || undefined,
          DebitChosenAccNo: (props.account && props.account.AccNo) || undefined,
          DebitAccBalance: (props.account && props.account.Balance) || undefined,
        }
      : {
          DebitAccNo: hasAcc ? props.initialAccountForDisabledField.AccNo : '',
          DebitChosenAccNo: hasAcc ? props.initialAccountForDisabledField.AccNo : '',
          DebitAccID: hasAcc ? props.initialAccountForDisabledField.AccountID : '',
          DebitAccHash: hasAcc ? props.initialAccountForDisabledField.HashSum_AccountID_ : '', // eslint-disable-line
          DebitTitleUNI: hasAcc ? props.initialAccountForDisabledField.TitleUNI : '',
          DebitAccBalance: props.debitBalance,

          CreditAccNo: (props.account && props.account.AccNo) || undefined,
          CreditTitleUNI: (props.account && props.account.TitleUNI) || undefined,
          CreditAccID: (props.account && props.account.ID) || undefined,
          CreditAccHash: (props.account && props.account.hash) || undefined,
          CreditChosenAccNo: (props.account && props.account.AccNo) || undefined,
          CreditAccBalance: (props.account && props.account.Balance) || undefined,
        }

    return {
      ...props,
      initialValues: {
        ClientType: '1',
        CCY: (props.account && props.account.CCY) || 'GEL',
        Authorize: '1',
        action: 'add',
        OperTypeID: props.cashOut ? 4 : 3,
        DocDate: props.OpenDay,
        OpCodeID: props.OpCode[0] && props.OpCode[0].ID,
        ...initialAccount,
        Name: '',
        Surname: '',
        // CityID: 1,
        // Address: '',
        // DOB: '',
        // DOBCheck:
        //   props.requiredFields && props.requiredFields.IND_DOB && props.requiredFields.IND_DOB.Active === 1 ? '1' : '0',
        // MobileNumber: '',
        // IDCardTypeID: 1,
        // CardNumber: '',
        CardNumberSearch: '',
        // OtherIDNumber: '',
        // IDCardIssuerID: 1,
        // IDCardRegDate: '',
        // IDCardRegDateCheck:
        //   props.requiredFields && props.requiredFields.IDCardRegDate && props.requiredFields.IDCardRegDate.Active === 1
        //     ? '1'
        //     : '0',
        // IDValidityDate: '',
        // IDValidityDateCheck:
        //   props.requiredFields &&
        //   props.requiredFields.IDValidityDate &&
        //   props.requiredFields.IDValidityDate.Active === 1
        //     ? '1'
        //     : '0',
        // AddUserInDB: '0',
        // CitizenshipID: props.MyCountryID,
        MoneyTransferCountryID: props.clientSelects.Country[0].ID,
        MoneyTransferSystemID: props.MoneyTransferSystem[0].ID,
        clientIsChosen: false,
        clientType: 0,
        clientID: '',
        clientHash: '',
      },
    }
  }),

  connect(
    (state) => ({
      clientWatched: formValueSelector(FORM_NAME)(state, 'clientWatched'),
    }),

    {
      openModal: LKModalActions.open,
      closeModalAction: LKModalActions.close,
      register: registerField,
      openError: LKModalActions.openError,
    },
  ),

  (Component) => (props) => {
    if (!props.initialAccountForDisabledField) {
      props.openError(translateFrmWebMsg('NO_CASH_ACC'), 'NO_CASH_ACC')
      props.closeModal()
      return null
    }

    return <Component {...props} />
  },

  reduxFormContainer,
)
